import styled from 'styled-components';
import IcoW01 from 'dc/IcoW01';
import Ico96 from 'dc/Ico96';
import { Typ30, Typ31, Typ41 } from 'dc/Typ';
import Mod001 from 'dc/Mod001';
import SeF001 from 'dc/Sef001';

export const Modal = styled(Mod001)`
  width: 494px !important;
  > div {
    border-radius: 5px;
    box-shadow:
      0 15px 20px rgba(0, 0, 0, 0.22),
      0 19px 60px rgba(0, 0, 0, 0.3);
  }
`;

export const CloseIconContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const CloseIcon = styled(IcoW01)`
  cursor: pointer;
  color: #607d8b;
  &:hover {
    color: #263238;
  }
`;

export const InnerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  background-color: transparent;
  text-align: center;
  padding-bottom: 88px;
`;

export const Icon = styled(Ico96)`
  color: #007079;
  padding-bottom: 16px;
`;

export const Heading = styled(Typ41)`
  width: 100%;
  padding-bottom: 32px;
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 22px;
  width: 100%;
  max-width: 378px;
`;

export const ContentHeader = styled(Typ31)`
  line-height: 17px;
`;

export const ContentText = styled(Typ30)`
  line-height: 17px;
`;

export const Footer = styled(SeF001)``;
